import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import FIELDS from '../../data/fields';
import { getProductsTelecomOptions, getResultFormulaProduct } from '../../app/store/actions/productTelecom';
import Autocomplete from 'react-autocomplete';

let selectedHelper = '';

class FormulaComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formula: [],
            product: '',
            meters: 1,
            points: 1,
            fixedValue: 0,
            resultFormula: 0,
            disableOperators: true,
            disableMeters: false,
            disablePoints: false,
            messageError: '',
            listProducts: [],
            products: '',
            product: {
                id: '',
                code: '',
            }
        };
    }
    componentDidMount = async () => {
        const { meters, points } = this.state;

        const listProducts = await this.props.getProductsTelecomOptions(this.props.productId, '', true);
        this.setState({ listProducts });

        if (this.props.formula.length > 0) {
            const disableOperators = false;
            let disableMeters = false;
            let disablePoints = false;
            for (const element of this.props.formula) {
                if (element.type === 'Meters') {
                    disableMeters = true;
                } else if (element.type === 'Points') {
                    disablePoints = true;
                }
            }
            this.setState({
                formula: this.props.formula || [],
                disableOperators,
                disableMeters,
                disablePoints
            })

            this.executeFormula(this.props.formula || [], meters, points);
        }

    }
    closeModal = () => this.props.closeModal();

    confirmModal = async () => {
        const { formula, meters, points } = this.state;

        if (!formula.length) {
            this.setState({
                messageError: I18n.t('emptyFormula')
            });
            return
        }

        const resultFormula = await this.executeFormula(formula, meters, points);

        if (!resultFormula.success) {
            this.setState({
                messageError: resultFormula.result
            });
            return
        }

        this.props.setFormula(formula);
        this.closeModal();
    }

    setOnChangeProduct = async (value) => {
        const listProducts = await this.props.getProductsTelecomOptions(this.props.productId, value, false);
        this.setState({ listProducts, products: value });
    };

    setValue = (att, value) => {
        if (value && value < 0) {
            this.setState({ [att]: Math.abs(value) });
        } else {
            this.setState({ [att]: value });
        }
    }

    addToFormula = async (value, type, disableOperator = false) => {
        const { formula, meters, points, disableOperators } = this.state;
        const formulaTemp = formula;
        formulaTemp.push({ value, type })

        if (value === '(' || value === ')') {
            disableOperator = disableOperators
        }

        this.setState({
            formula,
            disableOperators: disableOperator,
            messageError: ''
        });

        if (type === 'Meters') this.setState({ disableMeters: true })
        if (type === 'Points') this.setState({ disablePoints: true })

        await this.executeFormula(formula, meters, points);
    }


    handleKeyDown = async (event, value, attr) => {
        if (event.key === 'Enter') {
            await this.addToFormula(value, attr);
            this.setValue(attr, '');
        }
    }

    handleConfirm = async (value, attr) => {
        const { disableOperators, disableMeters, disablePoints } = this.state;
        if (disableOperators) {
            if ((attr === 'meters' && disableMeters) || (attr === 'points' && disablePoints)) {
                return
            }

            await this.addToFormula(value, attr);
            this.setValue(attr, '');
        }
    }

    setSelectedField = (item) => {
        selectedHelper = item;
        return `${item.code} ${item.description}`;
    };

    clearFormula = () => {
        this.setState({
            formula: [],
            disableOperators: true,
            disableMeters: false,
            disablePoints: false,
            listProducts: [],
            products: '',
            product: {
                id: '',
                code: '',
            }
        });
    }

    setSelectedProductId = async () => {
        await this.addToFormula({ id: selectedHelper.id, code: selectedHelper.code }, 'Product');

        this.setState({
            products: '',
            product: {
                id: '', code: '',
            },
        });
    };

    removeLastFormula = () => {
        const { formula, meters, points } = this.state;

        if (!formula.length) {
            return
        }

        const removeFormula = formula.pop();

        this.setState({
            formula
        });

        if (removeFormula.type !== 'Parentheses') {
            if (removeFormula.type === "Meters") {
                this.setState({ disableMeters: false, disableOperators: true })
            } else if (removeFormula.type === "Points") {
                this.setState({ disablePoints: false, disableOperators: true })
            } else if (removeFormula.type === "Operator") {
                this.setState({ disableOperators: false })
            } else if (removeFormula.type === "Product") {
                this.setState({
                    disableOperators: true,
                    products: '',
                    product: {
                        id: '', code: '',
                    },
                });
            } else {
                this.setState({ disableOperators: true })
            }
        }

        this.executeFormula(formula, meters, points);
    }

    getFormula = () => {
        const { formula } = this.state;
        let stringFormula = ''

        for (const item of formula) {
            if (item.type === 'Product') {
                stringFormula += item.value.code
            } else {
                stringFormula += item.value
            }
        }

        return stringFormula
    }

    executeFormula = async (formula, meters, points) => {
        let stringFormula = ''

        try {
            for (const item of formula) {
                if (item.type === "Meters") {
                    stringFormula += meters.toString();
                } else if (item.type === "Points") {
                    stringFormula += points.toString();
                } else if (item.type === "Product") {
                    const product = await this.props.getResultFormulaProduct(item.value.id, meters, points);
                    stringFormula += product.result.toString();
                } else {
                    stringFormula += item.value
                }
            }
            const result = stringFormula ? Math.ceil(eval(stringFormula)) : '-'
            this.setState({
                resultFormula: result
            })
            return { success: true, result }
        } catch (e) {
            this.setState({
                resultFormula: I18n.t('errorFormula'),
            })
            return { success: false, result: I18n.t('errorFormula') }
        }
    }

    onChangeParameters = (type, value) => {
        const { formula, meters, points } = this.state;
        this.setValue(type, value);
        this.executeFormula(formula, type === "meters" ? value : meters, type === "points" ? value : points);
    }

    render() {
        const { product, meters, points, fixedValue, disableOperators, resultFormula,
            disableMeters, disablePoints, messageError, listProducts, products } = this.state;

        return (
            <div className="p-10">
                <div className="d-flex flex-column">
                    <div className="d-flex flex-column p-10">
                        <span className="title-order-details">
                            {I18n.t('formula')}
                        </span>
                        <div className="row">
                            <span className="p-10 text-dark col-9 m-r-5  text-secondary" style={{ backgroundColor: '#e5e9ed', border: '1px solid #ccc', borderRadius: '5px', fontSize: '16px' }}>
                                {`=${this.getFormula()}`}
                            </span>
                            <div className='d-flex flex-column p-10 text-dark col text-center justify-content-center border border-dark rounded position-relative'>
                                <span className='position-absolute bg-white' style={{ marginTop: -45 }}>
                                    {I18n.t('result')}
                                </span>
                                <span className='font-weight-bold'>{resultFormula}</span>
                            </div>
                        </div>
                    </div>
                    <div className="row p-t-10 text-dark justify-content-center">
                        <div className="text-dark border border-dark position-relative col m-l-10">
                            <span className='position-absolute bg-white' style={{ marginTop: -10 }}>
                                {I18n.t('product')}
                            </span>
                            <div className='d-flex justify-content-center h-100 w-100 align-items-center search-custom-input position-relative'>
                                <Autocomplete
                                    getItemValue={item => this.setSelectedField(item)}
                                    items={listProducts || []}
                                    maxLength={FIELDS.max}
                                    renderItem={(item, isHighlighted) => (
                                        <div key={item.code} style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                                            {item.code}
                                            {' '}
                                            {item.description}
                                        </div>
                                    )}
                                    menuStyle={{ position: 'absolute', left: 0, top: 50 }}
                                    value={products}
                                    onChange={e => this.setOnChangeProduct(e.target.value)}
                                    onSelect={() => this.setSelectedProductId()}
                                    inputProps={{
                                        disabled: !disableOperators,
                                    }}
                                />
                                <i className="fa fa-check p-5 text-success" onClick={() => { this.handleConfirm(product, 'product') }} />
                            </div>
                        </div>
                        <div
                            className="d-flex flex-column p-10 text-dark border border-dark position-relative">
                            <span className='position-absolute bg-white' style={{ marginTop: -20 }}>
                                {I18n.t('fixedValue')}
                            </span>
                            <div className='d-flex flex-row align-items-center'>
                                <input
                                    className="form-control"
                                    maxLength={FIELDS.max}
                                    type="number"
                                    placeholder=""
                                    onChange={async e => this.setValue('fixedValue', await parseInt(e.target.value, 10) || 0)}
                                    value={fixedValue}
                                    style={{ width: '80px' }}
                                    onKeyDown={(e) => { this.handleKeyDown(e, fixedValue, 'fixedValue') }}
                                    disabled={!disableOperators}
                                />
                                <i className="fa fa-check p-5 text-success" onClick={() => { this.handleConfirm(fixedValue, 'fixedValue') }} />
                            </div>
                        </div>
                        <div
                            className="d-flex flex-column justify-content-center align-items-center p-10 text-dark border border-dark position-relative">
                            <span className='position-absolute bg-white' style={{ marginTop: -58 }}>
                                {I18n.t('params')}
                            </span>
                            <div className='d-flex flex-row align-items-center'>
                                {
                                    disableMeters ?
                                        <input
                                            className="form-control m-r-5"
                                            maxLength={FIELDS.max}
                                            type="number"
                                            placeholder=""
                                            onChange={e => this.onChangeParameters('meters', parseInt(e.target.value, 10) || 0)}
                                            value={meters}
                                            style={{ width: '100px' }}
                                        />
                                        :
                                        <button
                                            disabled={!disableOperators}
                                            className='btn mr-2'
                                            type="button"
                                            onClick={() => this.addToFormula(I18n.t('meters'), 'Meters')}>
                                            {I18n.t('meters')}
                                        </button>
                                }
                                {
                                    disablePoints ?
                                        <input
                                            className="form-control"
                                            maxLength={FIELDS.max}
                                            type="number"
                                            placeholder=""
                                            onChange={e => this.onChangeParameters('points', parseInt(e.target.value, 10) || 0)}
                                            value={points}
                                            style={{ width: '100px' }}
                                        />
                                        :
                                        <button
                                            disabled={!disableOperators}
                                            className='btn' type="button"
                                            onClick={() => this.addToFormula(I18n.t('points'), 'Points')}>
                                            {I18n.t('points')}
                                        </button>
                                }
                            </div>
                        </div>
                        <div className="d-flex flex-row p-10 text-dark border border-dark position-relative m-r-10">
                            <span className='position-absolute bg-white' style={{ marginTop: -20 }}>
                                {I18n.t('operators')}
                            </span>
                            <button disabled={disableOperators} title={I18n.t('sum')} className="p-8 m-2" type="button" onClick={() => this.addToFormula('+', 'Operator', true)}>+</button>
                            <button disabled={disableOperators} title={I18n.t('reduce')} className="p-8 m-2" type="button" onClick={() => this.addToFormula('-', 'Operator', true)}>-</button>
                            <button disabled={disableOperators} title={I18n.t('multiply')} className="p-8 m-2" type="button" onClick={() => this.addToFormula('*', 'Operator', true)}>*</button>
                            <button disabled={disableOperators} title={I18n.t('divide')} className="p-8 m-2" type="button" onClick={() => this.addToFormula('/', 'Operator', true)}>/</button>
                            <button title={I18n.t('openParentheses')} className="p-8 m-2" type="button" onClick={() => this.addToFormula('(', 'Parentheses', true)}>(</button>
                            <button title={I18n.t('closeParentheses')} className="p-8 m-2" type="button" onClick={() => this.addToFormula(')', 'Parentheses', true)}>)</button>
                            <button title={I18n.t('removeTheLast')} className="p-8 m-2" type="button" onClick={() => this.removeLastFormula()}>
                                <i className="fa fa-arrow-left" />
                            </button>
                            <button title={I18n.t('removeAll')} className="p-8 m-2" type="button" onClick={() => this.clearFormula()}>
                                <i className="fa fa-trash" />
                            </button>
                        </div>
                    </div>
                    <div className='text-center p-t-10'>
                        <h5 className='text-danger'>{messageError}</h5>
                    </div>
                </div>
                <div className="text-align-modal my-3">
                    <button
                        type="button"
                        className="btn btn-warning"
                        onClick={this.closeModal}
                    >
                        {I18n.t('cancel')}
                    </button>
                    <button
                        type="button"
                        className="btn btn-dark margin-left-btn-modal"
                        onClick={this.confirmModal}
                    >
                        {I18n.t('ok')}
                    </button>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    getProductsTelecomOptions: (productId, search, loading) => dispatch(getProductsTelecomOptions(productId, search, loading)),
    getResultFormulaProduct: (id, meters, points, loading) => dispatch(getResultFormulaProduct(id, meters, points, loading)),
});


export default connect(null, mapDispatchToProps)(FormulaComponent);
